import { ListDto } from "../types/dto/ListDto";
import { ApiService } from "./apiService";

// The phones the app has been used on, the last seen first.
export const getDevices = async (dto: ListDto & { blocked?: boolean }) => {
    return await ApiService.get(`devices?page=${dto.page}&size=${dto.size}${dto.blocked ? '&blocked=true' : ''}`)
}

// The phones one account was used on, each with every account on it.
export const getUserDevices = async (userId: string) => {
    return await ApiService.get(`devices/of-user/${userId}`)
}

export const blockDevice = async (id: string, reason?: string) => {
    return await ApiService.post(`devices/${id}/block`, reason ? { reason } : {});
}

export const unblockDevice = async (id: string) => {
    return await ApiService.post(`devices/${id}/unblock`, {});
}
